var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPokerWebsite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_71_630)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.7711 25C79.5945 25 120.406 25 161.229 25C161.437 25.098 161.645 25.2328 161.866 25.2818C167.281 26.3846 171.165 29.4601 173.505 34.4225C174.155 35.7948 174.498 37.3142 174.988 38.7723V121.688H25C25 121.136 25 120.756 25 120.377C25 93.9226 25 67.4686 25 41.0145C25.0123 34.3 29.1656 28.3941 35.4631 26.0292C36.5413 25.6249 37.6685 25.3431 38.7711 25ZM157.137 73.4602C157.137 62.9717 157.137 52.471 157.137 41.9825C157.137 38.4169 155.421 36.726 151.819 36.7138C144.591 36.7138 137.374 36.7138 130.146 36.7138C126.642 36.7138 124.89 38.4292 124.89 41.8845C124.89 62.8737 124.89 83.8629 124.89 104.852C124.89 108.222 126.654 109.974 130.048 109.974C137.325 109.974 144.591 109.974 151.868 109.974C155.421 109.974 157.124 108.246 157.124 104.656C157.124 94.2656 157.124 83.8629 157.124 73.4725L157.137 73.4602ZM83.8826 64.3931C83.8826 71.9531 83.8826 79.5254 83.8826 87.0854C83.8826 90.6755 85.5856 92.3787 89.1632 92.391C96.3796 92.391 103.608 92.391 110.825 92.391C114.402 92.391 116.117 90.6755 116.117 87.11C116.117 72.0756 116.117 57.0536 116.117 42.0193C116.117 38.4292 114.414 36.726 110.837 36.726C103.62 36.726 96.3918 36.726 89.1755 36.726C85.5979 36.726 83.8826 38.4292 83.8826 42.007C83.8826 49.469 83.8826 56.9433 83.8826 64.4053V64.3931ZM42.8633 55.6077C42.8633 60.2884 42.8633 64.9812 42.8633 69.6618C42.8633 73.0436 44.6153 74.808 47.9968 74.808C55.3112 74.808 62.6378 74.808 69.9522 74.808C73.3337 74.808 75.098 73.0436 75.098 69.6741C75.098 60.3986 75.098 51.1354 75.098 41.86C75.098 38.4782 73.346 36.7138 69.9645 36.7138C62.6501 36.7138 55.3235 36.7138 48.0091 36.7138C44.6275 36.7138 42.8755 38.4659 42.8633 41.8477C42.8633 46.4303 42.8633 51.0252 42.8633 55.6077Z",
    fill: "url(#paint0_linear_71_630)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175 134.284C174.78 135.068 174.571 135.852 174.339 136.636C172.354 143.277 166.093 148.032 159.146 148.032C119.707 148.056 80.2562 148.056 40.8173 148.032C31.5794 148.032 24.2282 139.822 25.1226 130.473H175V134.284Z",
    fill: "url(#paint1_linear_71_630)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0629 166.227V156.927H121.912V166.227C125.478 166.227 128.871 166.19 132.265 166.227C135.696 166.276 137.73 169.903 135.99 172.831C135.12 174.289 133.809 174.988 132.094 174.988C126.923 174.988 121.741 174.988 116.571 174.988C100.361 174.988 84.1643 174.988 67.955 174.988C65.5537 174.988 63.7036 173.456 63.3973 171.287C63.0788 169.045 64.4142 166.962 66.6073 166.361C67.1097 166.227 67.661 166.227 68.2001 166.214C71.4101 166.214 74.6201 166.214 78.0506 166.214L78.0629 166.227Z",
    fill: "url(#paint2_linear_71_630)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.76 101.066V80.7505H148.217V101.066H133.76Z",
    fill: "url(#paint3_linear_71_630)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.266 45.6216V54.2231H133.809V45.6216H148.266Z",
    fill: "url(#paint4_linear_71_630)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.809 63.1187H148.205V71.7692H133.809V63.1187Z",
    fill: "url(#paint5_linear_71_630)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.247 63.1802V83.4955H92.7651V63.1802H107.247Z",
    fill: "url(#paint6_linear_71_630)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.21 54.2231H92.7529V45.6216H107.21V54.2231Z",
    fill: "url(#paint7_linear_71_630)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.24 45.6216V65.9369H51.7827V45.6216H66.24Z",
    fill: "url(#paint8_linear_71_630)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_71_630",
    x1: 99.9939,
    y1: 25,
    x2: 99.9939,
    y2: 121.688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_71_630",
    x1: 100.024,
    y1: 130.473,
    x2: 100.024,
    y2: 148.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_71_630",
    x1: 99.9874,
    y1: 156.927,
    x2: 99.9874,
    y2: 174.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_71_630",
    x1: 140.989,
    y1: 80.7505,
    x2: 140.989,
    y2: 101.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_71_630",
    x1: 141.038,
    y1: 45.6216,
    x2: 141.038,
    y2: 54.2231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_71_630",
    x1: 141.007,
    y1: 63.1187,
    x2: 141.007,
    y2: 71.7692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_71_630",
    x1: 100.006,
    y1: 63.1802,
    x2: 100.006,
    y2: 83.4955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_71_630",
    x1: 99.9815,
    y1: 45.6216,
    x2: 99.9815,
    y2: 54.2231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_71_630",
    x1: 59.0113,
    y1: 45.6216,
    x2: 59.0113,
    y2: 65.9369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_71_630"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(25 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPokerWebsite);
export default __webpack_public_path__ + "static/media/Poker_Website.3cb6e722eac90c7064f664f536f9f8a8.svg";
export { ForwardRef as ReactComponent };